import { ApiClient } from '@webapp/core/services/ApiClient'
import { ApprovalChainRepository } from './ApprovalChainRepository'

export const approvalChainRepository = new ApprovalChainRepository({
  httpClient: ApiClient,
})
